<template>
  <div>
    <Header />
    <div class="container">
      <div class="jumbotron shadow-sm titlebox py-3 mb-3 mt-3 ">
        <p style="color: rgb(153, 0, 0);">
          The free API access for BotAmp has been suspended by Twitter. Due to the highly restricted access the paid API provides, we do not have an active plan to revive BotAmp. Consequently, the service will cease to function indefinitely. We apologize for any inconvenience this may cause.
        </p>
        <p style="color: rgb(153, 0, 0);">
          We condemn this decision by Twitter, which removes one of the best sources of social media platform transparency. Please read our <a href="https://independenttechresearch.org/letter-twitters-new-api-plans-will-devastate-public-interest-research" target="_blank" style="text-decoration: underline;">open letter</a> with the Coalition for Independent Technology Research for more information.
        </p>
      </div>
    </div>
    <div class="container">
      <div class="column d-flex flex-row justify-content-between">
        <div class="jumbotron py-3 shadow-sm query d-flex flex-fill">
          <div class="card-body">
            <b-row>
              <b-col>
                <p>
                  <b>1. Search Twitter for tweets of interest with a query</b>
                  <b-icon id="query-1-popover" icon="info-circle" class="ml-2" variant="secondary"></b-icon>
                </p>
                <b-popover target="query-1-popover" triggers="hover" placement="top">
                  The query can be a phrase like <code>happy hour</code>, a hashtag <code>#friday</code>, or any valid Twitter search operators.
                  <a href="https://developer.twitter.com/en/docs/twitter-api/v1/rules-and-filtering/search-operators" target='_blank'><b-icon icon="question-circle-fill" class="ml-1" variant="secondary"></b-icon></a>
                </b-popover>
              </b-col>
            </b-row>
             <b-row class="mb-3">
              <b-col cols="8">
                <b-input-group prepend="Query" class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input
                    id="query-1"
                    v-model="form.query_1.query"
                    type="text"
                    placeholder="Example: vaccines"
                    v-on:keyup.enter="liveSearch()"
                    ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col class="my-auto">
                <b-form-group class="my-auto">
                  <b-form-radio-group
                    id="query-1-result-type"
                    v-model="form.query_1.result_type"
                    name="radio-query-1-result-type">
                    <b-form-radio value="recent">Recent</b-form-radio>
                    <b-form-radio value="popular">Popular</b-form-radio>
                    <b-form-radio value="mixed">Mixed</b-form-radio>
                    <b-icon id="query-1-result-popover" icon="info-circle" variant="secondary"></b-icon>
                  </b-form-radio-group>
                </b-form-group>
                <b-popover target="query-1-result-popover" triggers="hover" placement="top">
                  Choose a Twitter search mode.
                  <b>Recent</b>: only the most recent tweets.
                  <b>Popular</b>: only the most popular tweets.
                  <b>Mixed</b>: mixture of both.
                  <a href="https://developer.twitter.com/en/docs/twitter-api/v1/tweets/search/api-reference/get-search-tweets" target='_blank'><b-icon icon="question-circle-fill" class="ml-1" variant="secondary"></b-icon></a>
                </b-popover>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p><b>2. Choose a baseline for comparison</b></p>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col id="baselinehometimeline">
                <b-form-radio v-model="form.baseline" name="some-radios" value="hometimeline">Compare with your home timeline <b-icon id="baselinehometimeline-popover" icon="info-circle" class="ml-2" variant="secondary"></b-icon></b-form-radio>
                <b-popover target="baselinehometimeline-popover" triggers="hover" placement="top">
                  Use the recent tweets from your home timeline as the baseline.
                  These tweets are posted by you and the accounts you follow.
                  <a href="https://developer.twitter.com/en/docs/twitter-api/v1/tweets/timelines/api-reference/get-statuses-home_timeline" target='_blank'><b-icon icon="question-circle-fill" class="ml-1" variant="secondary"></b-icon></a>
                </b-popover>
              </b-col>
              <b-col id="baselinequery-2">
                <b-form-radio v-model="form.baseline" name="some-radios" value="query_2">Compare with another query <b-icon id="baselinequery-2-popover" icon="info-circle" class="ml-2" variant="secondary"></b-icon></b-form-radio>
                <b-popover target="baselinequery-2-popover" triggers="hover" placement="top">
                  Use another query to search for tweets as the baseline.
                </b-popover>
              </b-col>
            </b-row>

            <b-row v-if="form.baseline==='query_2'">
              <b-col>
                <p>
                  <b>3. Search baseline tweets with another query</b>
                  <b-icon id="query-2-popover" icon="info-circle" class="ml-2" variant="secondary"></b-icon>
                </p>
                <b-popover target="query-2-popover" triggers="hover" placement="top">
                  The query can be a phrase like <code>happy hour</code>, a hashtag <code>#friday</code>, or any valid Twitter search operators.
                  <a href="https://developer.twitter.com/en/docs/twitter-api/v1/rules-and-filtering/search-operators" target='_blank'><b-icon icon="question-circle-fill" class="ml-1" variant="secondary"></b-icon></a>
                </b-popover>
              </b-col>
            </b-row>
            <b-row v-if="form.baseline === 'query_2'" class="mb-3">
              <b-col cols="8">
                <b-input-group prepend="Baseline query" class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input
                    id="query-2"
                    v-model="form.query_2.query"
                    type="text"
                    placeholder="Example: #covid"
                    v-on:keyup.enter="liveSearch()"
                    ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col class="my-auto">
                <b-form-group class="my-auto">
                  <b-form-radio-group
                    id="query-2-result-type"
                    v-model="form.query_2.result_type"
                    name="radio-query-2-result-type">
                    <b-form-radio value="recent">Recent</b-form-radio>
                    <b-form-radio value="popular">Popular</b-form-radio>
                    <b-form-radio value="mixed">Mixed</b-form-radio>
                    <b-icon id="query-2-result-popover" icon="info-circle" variant="secondary"></b-icon>
                  </b-form-radio-group>
                </b-form-group>
                <b-popover target="query-2-result-popover" triggers="hover" placement="top">
                  Choose a Twitter search mode.
                  <b>Recent</b>: only the most recent tweets.
                  <b>Popular</b>: only the most popular tweets.
                  <b>Mixed</b>: mixture of both.
                  <a href="https://developer.twitter.com/en/docs/twitter-api/v1/tweets/search/api-reference/get-search-tweets" target='_blank'><b-icon icon="question-circle-fill" class="ml-1" variant="secondary"></b-icon></a>
                </b-popover>
              </b-col>
            </b-row>
            <div class="h-center my-auto">
                <form @submit.stop.prevent="liveSearch()">
                  <div class="form-row">
                    <button id="submit" class="btn grayblue shadow-md">
                      Check BotAmp!
                    </button>
                    <b-popover v-if="query_missing" target="submit" triggers="hover" placement="left" variant="warning">
                      <template v-if="form.baseline === 'hometimeline'">Please type the query!</template>
                      <template v-else>Please type in both queries!</template>
                    </b-popover>
                    <b-spinner class="ml-2" variant="secondary" v-if="loading"></b-spinner>
                    <p v-if="loading" class="my-auto ml-2">{{ loadingMsg }}</p>
                  </div>
                </form>
            </div>

            <b-row class="mt-3" v-if="stats">
              <b-col>
                <p class="text-center"><b>Bot score distribution</b></p>
              </b-col>
              <b-col>
                <p class="text-center"><b>Bot activity comparison</b></p>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col>
                <div id="chart" v-if="series_box.length > 0">
                <apexchart ref="boxchart" type="boxPlot" height="410" width="500" :options="chartOptions_box" :series="series_box"></apexchart>
                </div>
              </b-col>
              <b-col>
                <div id="compareresult" class="text-center py-0 m-0 px-0" v-if="stats" >
                  <h2>
                    <template v-if="stats.u_test.p_value < 0.05">
                        <b-badge>{{ stats.query_1.query }}</b-badge>
                        <template v-if="stats.t_test.statistic > 0"> > </template>
                        <template v-else> < </template>
                        <b-badge>{{ stats.query_2.query }}</b-badge>
                    </template>
                    <template v-else>
                      <b-badge> Not significantly different </b-badge>
                    </template>
                  </h2>
                  <div class="pt-2">
                    <p>
                      <template v-if="stats.u_test.p_value < 0.05">
                        The likely bot activity of <b>{{ stats.query_1.query }}</b> is significantly
                        <template v-if="stats.t_test.statistic > 0">higher</template>
                        <template v-else>lower</template>
                        than that of <template v-if="form.baseline === 'hometimeline'"> your </template>
                        <b>{{ stats.query_2.query }}</b>
                      </template>
                      <template v-else>
                        The likely bot activity of <b>{{ stats.query_1.query }}</b> and <template v-if="form.baseline === 'hometimeline'"> your </template> <b>{{ stats.query_2.query }}</b> are not significantly different
                      </template>
                      <b-badge class="ml-2" variant="light" id="compareresultdetail" v-on:click="toggleDetailedStats()">
                        <template v-if="!showDetailedStats">show more</template><template v-else>show less</template>
                       </b-badge>
                      <b-popover v-if="!showDetailedStats && showHoverTip" target="compareresultdetail" triggers="hover" placement="bottom">
                        Click to view detailed statistics!
                      </b-popover>
                    </p>
                  </div>
                </div>
                <div v-if="stats && showDetailedStats" >
                  <p class="text-center">
                    Based on a two-sided Mann–Whitney U test (<i>p</i><template v-if="stats.u_test.p_value < 0.01"><0.01</template><template v-else>={{ stats.u_test.p_value }}</template>)
                    <router-link to="./faq#how" target="_blank"><b-icon icon="question-circle-fill" class="ml-1" variant="secondary"></b-icon></router-link>
                  </p>
                  <div class="mt-3">
                    <b-table striped hover :items="tweetsOtherStats.items" :fields="tweetsOtherStats.tableFields" small></b-table>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="error-msg" hide-footer title="Warning" header-bg-variant="warning">
      {{ errorMsg }}
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
import Header from './Header.vue';

export default {
  name: 'Botscore',
  components: {
    Header,
  },
  data () {
    return {
      msg: 'Hello world!',
      form: {
        baseline: 'hometimeline',
        query_1: {
          query: '',
          result_type: "mixed"
          },
        query_2: {
          query: '',
          result_type: "mixed"
          }
      },

      showDetailedStats: false,
      showHoverTip: true,

      loading: false,
      loadingMsg: "",

      errorMsg: "",

      tweetsPayloadRaw: {
        query_1: {
          query: null,
          tweets: []
        },
        query_2: {
          query: null,
          tweets: []
        }
      },

      tweetsOtherStats: {
        tableFields: [
          {key: "colName", label: ""},
          {key: "query_1", label: "Query"},
          {key: "query_2", label: "Baseline"}
        ],
        items: [],
        values: {
          firstTweetTime: {colName: "First tweet at", query_1: "", query_2: ""},
          lastTweetTime: {colName: "Last tweet at", query_1: "", query_2: ""},
          tweetCnt: {colName: "No. tweets ", query_1: 0, query_2: 0},
          uniqueAuthorCnt: {colName: "No. unique authors", query_1: 0, query_2: 0},
          meanRTcnt: {colName: "Average No. retweets", query_1: 0, query_2: 0},
          meanLikeCnt: {colName: "Average No. likes", query_1: 0, query_2: 0}
        }
      },

      stats: null,
      series: [],
      chartOptions: {
        chart: {
        height: 350,
        width: 350,
        type: 'area'
        },
        dataLabels: {
        enabled: false
        },
        stroke: {
        curve: 'smooth'
        },
        xaxis: {
          title: {
            text: 'Bot score'
          },
          type: 'numeric',
          decimalsInFloat: 1
        },
        yaxis: {
          decimalsInFloat: 2
        }
      },

      series_box: [],
      chartOptions_box: {
        chart: {
          type: 'boxPlot',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '50%'
          },
          boxPlot: {
            colors: {
              upper: '#e9ecef',
              lower: '#f8f9fa'
            }
          }
        },
        stroke: {
          colors: ['#6c757d']
        },
        xaxis: {
          title: {
            text: 'Bot score',
            style: {
              fontSize: '16px'
            }
          },
          min: 0,
          max: 1,
          type: 'numeric',
          decimalsInFloat: 1,
          tickAmount: 5,
          labels: {
            style:{
              fontSize: '16px'
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '16px'
            }
          }
        }
      }
    }
  },
  computed: {
    query_missing: function() {
      if(this.form.baseline === 'hometimeline'){
        return this.form.query_1.query.length == 0
      } else {
        return this.form.query_1.query.length == 0 || this.form.query_2.query.length == 0
      }
    }
  },
  methods: {
    async liveSearch() {
      var v = this;
      if(this.query_missing){
        if(this.form.baseline === 'hometimeline'){
          this.showErrorMsg("Please type in the query!");
        } else {
          this.showErrorMsg("Please type in both queries!");
        }
        return;
      }
      if(!this.$parent.twitter){
        this.$parent.twitterLogIn();
      }
      this.loading = true;
      this.loadingMsg = "Collecting tweets ...";
      this.tweetsPayloadRaw.query_1.query = this.form.query_1.query;
      this.tweetsPayloadRaw.query_1.tweets = []

      if(this.form.baseline === "hometimeline"){
        this.tweetsPayloadRaw.query_2.query = "home timeline";
        this.tweetsPayloadRaw.query_2.tweets = [];
        await Promise.all([
          this.getTwitterSearchResults("query_1"),
          this.getTwitterHomeTimeline()
        ])
      } else {
        this.tweetsPayloadRaw.query_2.query = this.form.query_2.query;
        this.tweetsPayloadRaw.query_2.tweets = []
        await Promise.all([
          this.getTwitterSearchResults("query_1"),
          this.getTwitterSearchResults("query_2")
        ])
      }

      if(this.loading){
        if(this.tweetsPayloadRaw["query_1"].tweets.length === 0){
          this.showErrorMsg("No tweets found for query '" + this.form.query_1.query + "', try another query.");
          this.cleanCachedData();
          return;
        }
        if(this.tweetsPayloadRaw["query_2"].tweets.length === 0){
          if(this.form.baseline === 'homeline'){
            this.showErrorMsg("No tweets in your home timeline. Please use another query as the baseline.")
            this.cleanCachedData();
            return;
          }else{
            this.showErrorMsg("No tweets found for query '" + this.form.query_2.query + "', try another query.");
            this.cleanCachedData();
            return;
          }
        }
        this.loadingMsg = "Analyzing tweets ...";
        this.genOtherTweetStats("query_1");
        this.genOtherTweetStats("query_2");
        this.formatOtherTweetStats();
        let reducedTweetPayload = this.reduceTweetPayload();
        try {
          var botampResponse = await axios({
            method: "POST",
            url: "https://botometer.osome.iu.edu/botamp/api/analyze-tweets",
            data: reducedTweetPayload,
            headers: {'Content-Type': 'application/json'}
          });
        } catch (error) {
          v.showErrorMsg("There is an error. Please try again later or contact the developers.");
          console.debug('ERROR CAUGHT');
          console.debug(error);
          v.cleanCachedData();
          return;
        }

        this.stats = botampResponse.data;
        this.series = [
          {
            name: this.stats['query_1']['query'],
            data: this.stats['query_1']['dist']
          },
          {
            name: this.stats['query_2']['query'],
            data: this.stats['query_2']['dist']
          },
        ]

        this.series_box = [
            {
            type: 'boxPlot',
            data: [
              {
                x: this.stats['query_1']['query'],
                y: this.stats['query_1']['quantiles']
              },
              {
                x: this.stats['query_2']['query'],
                y: this.stats['query_2']['quantiles']
              }
            ]
          }
        ]
        // Apexcharts bug: plot won't show correctly until window resizes
        // This trick triggers a "resize" event after data update
        window.dispatchEvent(new Event("resize"));
        this.loading = false;
        this.loadingMsg = "";
      }
    },
    async getTwitterHomeTimeline() {
      var v = this;
      var query_index = "query_2";
      var max_id = "";
      var query_limit = 2;
      var hometimeline = null;
      var query_done = false;

      async function paginateHomeTimelineRequests(query_index) {
        try {
          hometimeline = await v.$parent.twitter.getHomeTimeline(max_id);
        } catch (error) {
          if(error.error.status == 429){
            v.showErrorMsg("Twitter rate limit reached! Try again in 15 minutes or use another query as the baseline.")
          } else (
            v.showErrorMsg("There is an error. Please try again later or contact the developers.")
          )
          console.debug('ERROR CAUGHT');
          console.debug(error);
          v.cleanCachedData();
          return;
        }

        if(hometimeline.length > 0){
          max_id = hometimeline[hometimeline.length - 1]['id']
          v.tweetsPayloadRaw[query_index].tweets = v.tweetsPayloadRaw[query_index].tweets.concat(hometimeline);
        } else {
          query_done = true;
        }

        query_limit -= 1;

        if (!query_done && query_limit > 0){
          await paginateHomeTimelineRequests(query_index);
        }
      }

      await paginateHomeTimelineRequests(query_index);
    },
    async getTwitterSearchResults(query_index) {
      var tweetsResponse = null;
      var v = this;
      var max_id = "";
      var lang = "";
      var twitter_result_type = this.form[query_index].result_type;
      var query_limit = 4;
      var query_done = false;

      // This function will paginate tweet search requests and is recursive
      async function paginateTwitterRequests(query_index) {
        try {
          if(lang && lang != undefined && lang != '' && lang != 'any')
          {
            tweetsResponse = await v.$parent.twitter.getTweets(v.tweetsPayloadRaw[query_index].query, lang, max_id, twitter_result_type);
          }
          else
          {
            tweetsResponse = await v.$parent.twitter.getTweets(v.tweetsPayloadRaw[query_index].query, '', max_id, twitter_result_type);
          }
        } catch (error) {
          if(error.error.status == 429){
            v.showErrorMsg("Twitter rate limit reached! Try again in 15 minutes.")
          } else (
            v.showErrorMsg("There is an error. Please try again later or contact the developers.")
          )
          console.debug('ERROR CAUGHT');
          console.debug(error);
          v.cleanCachedData();
          return;
        }

        query_limit -= 1;
        if (tweetsResponse.search_metadata.next_results)
        {
          // Retrieving the max id from the next_results query string
          let next_url = tweetsResponse.search_metadata.next_results;
          let pieces = next_url.split("?")[1].split("&");
          for(let i in pieces){
              let piece = pieces[i];
              let variable = piece.split("=");
              if( variable[0] == 'max_id' ){
                  max_id = variable[1];
                  break;
              }
          }
        }
        else
        {
          query_done = true;
        }
        v.tweetsPayloadRaw[query_index].tweets = v.tweetsPayloadRaw[query_index].tweets.concat(tweetsResponse.statuses);

        if (!query_done && query_limit > 0)
        {
          // Continue pagination
          await paginateTwitterRequests(query_index)
        }
      }

      await paginateTwitterRequests(query_index);
    },
    reduceTweetPayload() {
      return {
        query_1: {
          query: this.tweetsPayloadRaw.query_1.query,
          tweets: this.tweetsPayloadRaw.query_1.tweets.map(this.reduceTweetObject)
        },
        query_2: {
          query: this.tweetsPayloadRaw.query_2.query,
          tweets: this.tweetsPayloadRaw.query_2.tweets.map(this.reduceTweetObject)
        },
      }
    },
    formatOtherTweetStats(){
      this.tweetsOtherStats.items = [];
      var v = this;
      Object.keys(this.tweetsOtherStats.values).forEach(function(key){
        v.tweetsOtherStats.items = v.tweetsOtherStats.items.concat(v.tweetsOtherStats.values[key]);
      });
      this.tweetsOtherStats.tableFields = [
        {key: "colName", label: ""},
        {key: "query_1", label: this.tweetsPayloadRaw.query_1.query},
        {key: "query_2", label: this.tweetsPayloadRaw.query_2.query}
      ];
    },
    genOtherTweetStats(query_index) {
      let firstTweet = this.tweetsPayloadRaw[query_index].tweets[0];

      var firstTweetTime = firstTweet.created_at;
      var lastTweetTime = firstTweet.created_at;
      var authorsIDs = new Set();
      authorsIDs.add(firstTweet.user.id_str);
      var RTcnt = firstTweet.retweet_count;
      var likeCnt = firstTweet.favorite_count;

      for(let i=1; i<this.tweetsPayloadRaw[query_index].tweets.length; i++){
        let focalTweet = this.tweetsPayloadRaw[query_index].tweets[i];
        if(focalTweet.created_at > lastTweetTime){
          lastTweetTime = focalTweet.created_at;
        }
        if(focalTweet.created_at < firstTweet){
          firstTweetTime = focalTweet.created_at;
        }
        authorsIDs.add(focalTweet.user.id_str);
        RTcnt += focalTweet.retweet_count;
        likeCnt += focalTweet.favorite_count;
      }

      this.tweetsOtherStats.values.tweetCnt[query_index] = this.tweetsPayloadRaw[query_index].tweets.length;
      this.tweetsOtherStats.values.firstTweetTime[query_index] = moment(firstTweetTime).format("YYYY-MM-DD kk:mm");
      this.tweetsOtherStats.values.lastTweetTime[query_index] = moment(lastTweetTime).format("YYYY-MM-DD kk:mm");
      this.tweetsOtherStats.values.uniqueAuthorCnt[query_index] = authorsIDs.size;
      this.tweetsOtherStats.values.meanRTcnt[query_index] = (RTcnt / this.tweetsOtherStats.values.tweetCnt[query_index]).toFixed();
      this.tweetsOtherStats.values.meanLikeCnt[query_index] = (likeCnt / this.tweetsOtherStats.values.tweetCnt[query_index]).toFixed();
    },
    reduceTweetObject(tweet_obj) {
      return {
        created_at: tweet_obj.created_at,
        user: tweet_obj.user
      }
    },
    toggleDetailedStats() {
      this.showDetailedStats = !this.showDetailedStats;
      this.showHoverTip = false;
    },
    showErrorMsg(errorMsg) {
      this.errorMsg = errorMsg;
      this.$refs['error-msg'].show();
    },
    cleanCachedData() {
      this.stats = null;
      this.series = [];
      this.series_box = [];
      this.loading = false;
      this.loadingMsg = "";
    }
  }
}
</script>


<style scoped>

.query {
  background-color: #e9ecef;
}

.grayblue {
  color: #f8f8f8;
  background-color: #4e759c;
}

.grayblue:hover, .grayblue:active, .grayblue:focus, .grayblue.active {
  color: #f8f8f8;
  background-color: #38536e;
}

.fa-question-circle, #tabs .nav-item {
  color: #478fd8;
}

.fa-question-circle:hover, #tabs .nav-item {
  color: #04488b;
  cursor: pointer;
}

.h-center {
  left: 40%;
  position: relative;
}

.text-center {
  text-align: center;
}

.column {
  flex: 100%;
}

p a {
  color: #0364CB;
}

</style>
